var _defs, _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanzer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 159.38,
    width: 159.38,
    viewBox: "0 0 159.38 159.38",
    y: "0px",
    x: "0px",
    id: "Ebene_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs33"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style10",
    type: "text/css"
  }, "\n\t.st0{fill:#A71923;}\n")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,62.52)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a71923"
    },
    id: "path12",
    d: "M 54.58,0 H 49.83 C 49.21,0 48.58,0.12 47.96,1.62 L 39.22,22.85 H 50.96 V 12.62 c 0,-0.62 0.5,-1.25 1.25,-1.25 0.62,0 1.25,0.5 1.25,1.25 V 22.86 H 65.2 L 56.46,1.62 C 55.83,0.12 55.33,0 54.58,0 Z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a71923"
    },
    id: "rect14",
    height: 6.5,
    width: 19.49,
    className: "st0",
    y: 0,
    x: 114.29
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a71923"
    },
    id: "path16",
    d: "M 81.44,8.99 74.32,0.75 C 73.95,0.25 73.2,0 72.57,0 h -4.5 c -1,0 -1.25,0.37 -1.25,1.25 v 21.61 h 6.99 V 12.74 l 3.25,3.75 v 6.5 h 5.37 c 4.87,0 6,-2 6,-5.75 V 0 h -6.99 z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a71923"
    },
    id: "path18",
    d: "M 15.11,0 H 0 v 6.5 h 10.49 c 0.62,0 1.25,0.5 1.25,1.25 0,0.62 -0.5,1.25 -1.25,1.25 H 0 v 13.99 h 8.99 v -7.37 h 6.12 c 3.75,0 5.5,-3 5.37,-8.12 C 20.48,1.75 18.86,0 15.11,0 Z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a71923"
    },
    id: "path20",
    d: "M 31.48,14.49 V 0 h -8.99 v 17.24 c 0,4.37 2.12,5.62 6,5.62 h 9.49 V 16.61 H 33.36 C 32.1,16.49 31.48,15.49 31.48,14.49 Z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a71923"
    },
    id: "path22",
    d: "m 111.67,5.87 c 0.37,-0.87 0.37,-1.5 0.37,-3 0,-2.62 -0.5,-2.87 -2.12,-2.87 H 91.18 v 6.5 h 9.24 l -8.12,8.62 c -0.37,0.5 -2,1.75 -2,3.75 0,0.75 0,1.5 0,2.25 0,1.5 0.12,1.75 2.12,1.75 h 19.24 v -6.25 h -9.12 l 7.37,-8.24 c 0.38,-0.64 1.51,-1.88 1.76,-2.51 z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a71923"
    },
    id: "path24",
    d: "m 152.39,13.37 c 3.5,-0.25 4.25,-1.87 4.25,-6.87 0,-4.87 -1.25,-6.5 -4.87,-6.5 h -15.24 v 6.5 h 10.74 c 0.62,0 1.25,0.5 1.25,1.25 0,0.62 -0.5,1.25 -1.25,1.25 h -10.74 v 13.99 h 8.87 V 15.5 l 2.37,3.5 v 3.87 h 11.62 z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a71923"
    },
    id: "path26",
    d: "m 125.03,16.49 c -2,0 -1.87,-2.12 -1.87,-2.12 h 4.75 V 8.87 H 114.3 v 7.99 c 0,3.37 2.62,5.87 6,5.87 h 14.11 v -6.25 z",
    className: "st0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanzer);
export default __webpack_public_path__ + "static/media/planzer.f55378d1.svg";
export { ForwardRef as ReactComponent };